import { useEffect } from 'react'
import { useQuery } from '@apollo/client'
import Loader from '../../../../Global/Spinner'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import { GET_COUNT_ALL_TICKETS } from '../../../../../graphql/Catalog/ReportsQueries/reportsQueries'

const GetTicketsCountItem = ({ status, label = null, filters }) => {
  //QUERIES:
  const { loading, error, data } = useQuery(GET_COUNT_ALL_TICKETS, {
    variables: {
      statusId: status?.id ?? null,
      filters: { dateFrom: filters.dateFrom, dateTo: filters.dateTo },
    },
    fetchPolicy: 'cache-and-network',
  })

  //EFFECTS:
  useEffect(() => {
    if (!loading) {
      if (error)
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error, data])

  if (loading) return <Loader size="2rem" />

  if (!status) {
    return (
      <div
        className="border border-1 mr-3 mb-3"
        style={{ borderRadius: 5, width: 110, boxSizing: 'border-box' }}
      >
        <div
          className="bg-black py-1 text-center text-uppercase text-bold"
          style={{ fontSize: 20 }}
        >
          TOTAL
        </div>
        <div className="p-0 text-center">
          <h2 className="text-bold p-0 m-0" style={{ fontSize: 40 }}>
            {data?.result}
          </h2>
        </div>
      </div>
    )
  }

  if (status.name === 'nuevo') {
    return (
      <div
        className="border border-1 mr-3 mb-3"
        style={{ borderRadius: 5, width: 110, boxSizing: 'border-box' }}
      >
        <div
          className="py-1 text-center text-uppercase text-bold border border-left-0 border-right-0 border-top-0 border-bottom-1"
          style={{ fontSize: 14 }}
        >
          <i className="fas fa-user-tie mr-1" style={{ fontSize: 12 }} />
          {label ? label : status.labelMain}
        </div>
        <div className="p-0 text-center">
          <h4 className="text-bold p-0 m-0">{data?.result}</h4>
        </div>
      </div>
    )
  }

  return (
    <div
      className="border border-1 mr-3 mb-3"
      style={{ borderRadius: 5, width: 110, boxSizing: 'border-box' }}
    >
      <div
        className={`customBg-${status.classColorTxt} py-1 text-center text-white text-uppercase text-bold`}
        style={{ fontSize: 14 }}
      >
        {label ? label : status.labelMain}
      </div>
      <div className="p-0 text-center">
        <h4 className="text-bold p-0 m-0">{data?.result}</h4>
      </div>
    </div>
  )
}

export default GetTicketsCountItem
